// extracted by mini-css-extract-plugin
export default {"title":"PageNotFound_title__wtlU9"};